import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_GLOBAL_VENDORS, GET_GLOBAL_VENDORS_SUCCESS, GET_GLOBAL_VENDORS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getGlobalVendors(action) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const id = action?.payload?.id;
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/vendors/${id}`,
      method: 'GET',
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      yield put({ type: GET_GLOBAL_VENDORS_SUCCESS, payload: response?.data });
    } else {
      yield put({ type: GET_GLOBAL_VENDORS_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_GLOBAL_VENDORS_ERROR, payload: error });
  }
}

export function* watchGetGlobalVendors() {
  yield takeLatest(GET_GLOBAL_VENDORS, getGlobalVendors);
}

function* getGlobalVendorsSaga() {
  yield all([fork(watchGetGlobalVendors)]);
}

export default getGlobalVendorsSaga;
